import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-subtitle-2 text-medium-emphasis",
  style: {"color":"black"}
}
const _hoisted_2 = { class: "mr-2" }
const _hoisted_3 = { class: "pr-2" }
const _hoisted_4 = {
  class: "d-flex align-center",
  style: {"flex-wrap":"wrap"}
}
const _hoisted_5 = { class: "pr-2" }
const _hoisted_6 = { class: "w-100 d-flex flex-column" }
const _hoisted_7 = {
  key: 0,
  class: "pt-3 pb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_combobox_filled = _resolveComponent("v-combobox-filled")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_tag_manager = _resolveComponent("tag-manager")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.$vuetify.display.mobile && _ctx.syncedInDialog === null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.splitUserPartitions)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "d-flex align-center v-col-auto pr-3 title" }, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode(" Etiquettes ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_divider)
                    ]),
                    _: 1
                  }),
                  (_ctx.isExpandable)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        class: "d-flex align-center v-col-auto pl-3 title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn_icon, {
                            icon: _ctx.expanded ? '$remove' : '$add',
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.splitUserPartitions || !_ctx.expanded)
            ? (_openBlock(), _createBlock(_component_v_combobox, {
                key: 1,
                modelValue: _ctx.model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model) = $event)),
                filter: _ctx.filter,
                "hide-no-data": !_ctx.search,
                items: _ctx.filteredCompanyTags,
                "search-input": _ctx.search,
                "onUpdate:searchInput": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event)),
                "hide-selected": "",
                variant: "underlined",
                placeholder: "Sélectionner ou créer une étiquette",
                multiple: "",
                "hide-details": "",
                "item-value": "id",
                "item-title": "text",
                "single-line": "",
                "onUpdate:focused": _ctx.onFocus,
                readonly: !_ctx.currentUser.profile || !_ctx.currentUser.profile.configuration.tag.write,
                "prepend-inner-icon": "$label_outline"
              }, {
                "no-data": _withCtx(() => [
                  _createVNode(_component_v_list_item, { class: "oss-list-item" }, {
                    default: _withCtx(() => [
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "subheading" }, "Créer", -1)),
                      _createVNode(_component_v_chip, {
                        class: "ml-1",
                        color: "tagFree",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.search), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                selection: _withCtx(({ item, index }) => [
                  (item === Object(item))
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        color: `${item.raw.color}`,
                        variant: item.raw.type === 'SubAccountableAccount' ? 'outlined' : 'flat',
                        "text-color": "black",
                        size: "small",
                        label: ""
                      }, {
                        default: _withCtx(() => [
                          (
                                item.raw.partitionTag && item.raw.partitionTag.type === 'Building'
                            )
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                density: "compact",
                                size: "x-small",
                                class: "pr-2"
                              }, {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode("$fa-building")
                                ])),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getTagName(item.raw)), 1),
                          (_ctx.isRemoveable(item.raw))
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 1,
                                size: "small",
                                onClick: ($event: any) => {
                                _ctx.tagGate();
                                _ctx.removeItemWithIndex(index);
                            },
                                class: "ml-2"
                              }, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                  _createTextVNode("$close")
                                ])),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["color", "variant"]))
                    : _createCommentVNode("", true)
                ]),
                item: _withCtx(({ index, item, props }) => [
                  _createVNode(_component_v_list_item, _mergeProps(props, {
                    style: {
                            minHeight: '30px',
                            pointerEvents: item.raw.header ? 'none' : 'auto',
                        }
                  }), {
                    title: _withCtx(() => _cache[20] || (_cache[20] = [])),
                    default: _withCtx(() => [
                      (_ctx.editing === item.raw)
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 0,
                            modelValue: _ctx.editing.text,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editing.text) = $event)),
                            autofocus: "",
                            text: "",
                            "background-color": "transparent",
                            "hide-details": "",
                            solo: "",
                            onKeyup: _withKeys(($event: any) => (_ctx.edit(index, item.raw)), ["enter"]),
                            class: "text_field_tag"
                          }, null, 8, ["modelValue", "onKeyup"]))
                        : (item.raw.header)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.raw.header), 1))
                          : (_openBlock(), _createBlock(_component_v_chip, {
                              key: 2,
                              color: `${item.raw.color}`,
                              variant: 
                                item.raw.type === 'SubAccountableAccount' ? 'outlined' : 'flat'
                            ,
                              size: "small",
                              label: ""
                            }, {
                              default: _withCtx(() => [
                                (
                                    item.raw.partitionTag &&
                                    item.raw.partitionTag.type === 'Building'
                                )
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      dense: "",
                                      size: "x-small",
                                      class: "pr-2"
                                    }, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode(" $fa-building ")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", null, _toDisplayString(_ctx.getTagNameToSelect(item.raw)), 1)
                              ]),
                              _: 2
                            }, 1032, ["color", "variant"]))
                    ]),
                    _: 2
                  }, 1040, ["style"])
                ]),
                "prepend-item": _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "d-flex justify-end px-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "secondary",
                            size: "small",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogTagManager = true))
                          }, {
                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                              _createTextVNode("$fa-gear")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "filter", "hide-no-data", "items", "search-input", "onUpdate:focused", "readonly"]))
            : _createCommentVNode("", true),
          (_ctx.visiblePartitions.length)
            ? (_openBlock(), _createBlock(_component_v_container, { key: 2 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partitionTags, (partitionTag, index) => {
                    return (_openBlock(), _createBlock(_component_v_row, {
                      key: index,
                      class: "align-center mb-2",
                      "no-gutters": ""
                    }, {
                      default: _withCtx(() => [
                        (partitionTag.partitionTag.name !== 'OtherPartition')
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "5",
                              class: "d-flex align-center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(partitionTag.partitionTag.name), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          cols: partitionTag.partitionTag.name !== 'OtherPartition' ? 7 : 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_combobox_filled, {
                              modelValue: partitionTag.model,
                              "onUpdate:modelValue": [($event: any) => ((partitionTag.model) = $event), ($event: any) => (_ctx.onPartitionTagChanged(partitionTag))],
                              filter: _ctx.filter,
                              "hide-no-data": !partitionTag.search,
                              items: partitionTag.tags,
                              "search-input": partitionTag.search,
                              "onUpdate:searchInput": ($event: any) => ((partitionTag.search) = $event),
                              "hide-selected": "",
                              label: "Sélectionner ou créer une étiquette",
                              multiple: "",
                              class: _normalizeClass({ 'v-text-field--outlined': _ctx.outlined }),
                              style: {
                                    padding: '0 0 4px 0',
                                    height: '40px',
                                    overflow: 'hidden',
                                    'white-space': 'nowrap',
                                    width: '100%',
                                    'box-sizing': 'border-box',
                                    'border-radius': '8px',
                                },
                              density: "compact",
                              "hide-details": "",
                              "item-value": "id",
                              "item-title": "text",
                              "single-line": "",
                              "onUpdate:focused": _ctx.onFocus,
                              readonly: 
                                    !_ctx.currentUser.profile ||
                                    !_ctx.currentUser.profile.configuration.tag.write
                                ,
                              "background-color": '#FAFAFA'
                            }, {
                              "no-data": _withCtx(() => [
                                _createVNode(_component_v_list_item, { class: "oss-list-item" }, {
                                  default: _withCtx(() => [
                                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "subheading" }, "Créer", -1)),
                                    _createVNode(_component_v_chip, {
                                      class: "ml-1",
                                      color: "tagFree",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(partitionTag.search), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              selection: _withCtx(({ item, index }) => [
                                (item === Object(item))
                                  ? (_openBlock(), _createBlock(_component_v_chip, {
                                      key: 0,
                                      color: `${item.raw.color}`,
                                      variant: 
                                            item.raw.type === 'SubAccountableAccount'
                                                ? 'outlined'
                                                : 'flat'
                                        ,
                                      "text-color": "black",
                                      "model-value": true,
                                      size: "small",
                                      label: ""
                                    }, {
                                      default: _withCtx(() => [
                                        (
                                                partitionTag.partitionTag &&
                                                partitionTag.partitionTag.type === 'Building'
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 0,
                                              density: "compact",
                                              size: "x-small",
                                              class: "pr-2"
                                            }, {
                                              default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                _createTextVNode("$fa-building")
                                              ])),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getTagName(item.raw)), 1),
                                        (_ctx.isRemoveable(item))
                                          ? (_openBlock(), _createBlock(_component_v_icon, {
                                              key: 1,
                                              size: "x-small",
                                              onClick: ($event: any) => ((_ctx.tagGate(), _ctx.removeItemWithIndex(index))),
                                              class: "ml-2"
                                            }, {
                                              default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                _createTextVNode("$close")
                                              ])),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["color", "variant"]))
                                  : _createCommentVNode("", true)
                              ]),
                              item: _withCtx(({ index, item, props }) => [
                                _createVNode(_component_v_list_item, _mergeProps({ ref_for: true }, props), {
                                  title: _withCtx(() => _cache[26] || (_cache[26] = [])),
                                  default: _withCtx(() => [
                                    (_ctx.editing === item)
                                      ? (_openBlock(), _createBlock(_component_v_text_field, {
                                          key: 0,
                                          modelValue: _ctx.editing.text,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editing.text) = $event)),
                                          autofocus: "",
                                          text: "",
                                          "background-color": "transparent",
                                          "hide-details": "",
                                          solo: "",
                                          onKeyup: _withKeys(($event: any) => (_ctx.edit(index, item)), ["enter"]),
                                          class: "text_field_tag"
                                        }, null, 8, ["modelValue", "onKeyup"]))
                                      : (_openBlock(), _createBlock(_component_v_chip, {
                                          key: 1,
                                          color: `${item.raw.color}`,
                                          variant: 
                                                item.raw.type === 'SubAccountableAccount'
                                                    ? 'outlined'
                                                    : 'flat'
                                            ,
                                          "text-color": "black",
                                          label: "",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.getTagNameToSelect(item.raw)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["color", "variant"]))
                                  ]),
                                  _: 2
                                }, 1040)
                              ]),
                              "prepend-item": _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "d-flex justify-end px-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          color: "secondary",
                                          size: "small",
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogTagManager = true))
                                        }, {
                                          default: _withCtx(() => _cache[27] || (_cache[27] = [
                                            _createTextVNode("$fa-gear")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "filter", "hide-no-data", "items", "search-input", "onUpdate:searchInput", "class", "onUpdate:focused", "readonly"])
                          ]),
                          _: 2
                        }, 1032, ["cols"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _withDirectives(_createVNode(_component_v_text_field_filled, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialog = true)),
            label: _ctx.model.length ? '' : 'Etiquettes',
            "hide-details": "",
            height: "20px",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model, (tag) => {
                  return (_openBlock(), _createBlock(_component_v_chip, {
                    key: tag.name,
                    color: `${tag.color}`,
                    "input-value": tag.name,
                    size: "small",
                    label: "",
                    class: "ma-1",
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [
                      (tag.partitionTag && tag.partitionTag.type === 'Building')
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            dense: "",
                            size: "x-small",
                            class: "pr-2"
                          }, {
                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                              _createTextVNode("$fa-building")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getTagName(tag)), 1),
                      (_ctx.isRemoveable(tag))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            size: "small",
                            onClick: _withModifiers(($event: any) => ((_ctx.tagGate(), _ctx.removeItem(tag))), ["stop"])
                          }, {
                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                              _createTextVNode("$close")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["color", "input-value"]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["label"]), [
            [_vShow, _ctx.syncedInDialog === null]
          ]),
          _createVNode(_component_oss_dialog, {
            modelValue: _ctx.dialog,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialog) = $event)),
            fullscreen: _ctx.syncedInDialog === null,
            "hide-overlay": "",
            title: "Etiquettes"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "9",
                      class: "pt-1 pb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field_filled, {
                          modelValue: _ctx.searchText,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchText) = $event)),
                          autofocus: "",
                          text: "",
                          label: "Recherche",
                          onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.addNewTag()), ["enter"])),
                          density: "compact"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "3",
                      class: "pl-2 text-right d-flex align-center justify-end"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          elevation: "0",
                          rounded: "",
                          disabled: !_ctx.searchText,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addNewTag())),
                          loading: _ctx.addNewTagLoading,
                          size: "x-small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.tagExists() ? "Ajouter" : "Choisir"), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider, { class: "mx-3" }),
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  style: {"height":"calc(90vh - 171px)","overflow-y":"auto"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAllCompanyTags, (tag) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        cols: "12",
                        key: tag.id
                      }, {
                        default: _withCtx(() => [
                          (tag.header)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("strong", null, _toDisplayString(tag.header), 1)
                              ]))
                            : (_openBlock(), _createBlock(_component_v_row, {
                                key: 1,
                                "no-gutters": "",
                                onClick: ($event: any) => (_ctx.addTag(tag)),
                                class: "py-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "9" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_chip, {
                                        variant: "flat",
                                        color: `${tag.color}`,
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          (
                                                tag.partitionTag &&
                                                tag.partitionTag.type === 'Building'
                                            )
                                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 0,
                                                dense: "",
                                                size: "x-small",
                                                class: "pr-2"
                                              }, {
                                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                  _createTextVNode("$fa-building")
                                                ])),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.getTagNameToSelect(tag)), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, {
                                    cols: "3",
                                    class: "pl-2 d-flex align-center justify-end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        elevation: "0",
                                        rounded: "",
                                        loading: _ctx.addTagLoading,
                                        size: "x-small"
                                      }, {
                                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                                          _createTextVNode(" Choisir ")
                                        ])),
                                        _: 1
                                      }, 8, ["loading"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])),
                          _createVNode(_component_v_divider)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "fullscreen"])
        ], 64)),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar.display,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.snackbar.display) = $event)),
      "multi-line": "",
      timeout: 15000,
      absolute: "",
      width: "auto",
      "max-width": "none",
      style: {"position":"fixed","margin-top":"64px"},
      location: "top end"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.createOneSuggestion()), ["stop"])),
          variant: "text"
        }, {
          default: _withCtx(() => _cache[32] || (_cache[32] = [
            _createTextVNode(" Appliquer ")
          ])),
          _: 1
        }),
        _createVNode(_component_v_btn_icon, {
          icon: "$oss-close",
          size: "small",
          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.snackbar.display = false), ["stop"]))
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("strong", null, _toDisplayString(_ctx.snackbarText), 1)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.dialogTagManager)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 2,
          title: "Gérer vos étiquettes et journaux",
          modelValue: _ctx.dialogTagManager,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dialogTagManager) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_tag_manager)
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}